// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_12Kh7","divider":"_1w0Xz"};